import { render } from "./SensiWord.vue?vue&type=template&id=7814ec37&scoped=true"
import script from "./SensiWord.vue?vue&type=script&lang=js"
export * from "./SensiWord.vue?vue&type=script&lang=js"

import "./SensiWord.vue?vue&type=style&index=0&id=7814ec37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7814ec37"]])

export default __exports__